<template>
  <div
    class="popup"
    :style="{ visibility: show ? 'unset' : 'hidden' }"
    ref="pop"
  >
    <div class="top" v-if="!mobile">
      <button @click="close">
        <img src="@/assets/images/icons/close.svg" alt="close" />
      </button>
    </div>
    <div class="mobile-header" v-if="mobile">
      <div class="title">
        Новая запись
      </div>
      <button @click="close">
        <img src="@/assets/images/icons/close.svg" alt="close" />
      </button>
    </div>
    <preload-content :loading="loading" min-height="120px">
      <template v-if="!loading">
        <template v-if="!emptyCoworking">
          <div>
            <CustomInput
              mb="10px"
              v-model="form.title"
              placeholder="Название"
              @change="errors.name = null"
            />
            <error-text :text="errors.name" />
          </div>
          <div>
            <CustomInput
              mb="10px"
              v-model="form.price"
              type="number"
              placeholder="Цена"
              :step="0.01"
              @change="errors.sum = null"
            />
            <error-text :text="errors.sum" />
          </div>
          <div>
            <custom-select
              mb="10px"
              max-width="100%"
              placeholder="Коворкинг"
              @change="
                form.cowork = $event;
                errors.coworking_id = null;
              "
              :value="form.cowork"
            >
              <option
                v-for="({ id, name }, i) in coworking"
                :value="id"
                :key="i + 'cowork'"
              >
                {{ name }}</option
              >
            </custom-select>
            <error-text :text="errors.coworking_id" />
          </div>
          <transition name="fade">
            <div v-if="types">
              <custom-select
                mb="10px"
                max-width="100%"
                placeholder="Зона"
                @change="
                  form.type = $event;
                  errors.zone_id = null;
                "
                :value="form.type"
              >
                <option
                  v-for="(type, i) in types"
                  :value="type.id"
                  :key="i + 'type'"
                >
                  {{ type.name }}</option
                >
              </custom-select>
              <error-text :text="errors.zone_id" />
            </div>
          </transition>
        </template>

        <div>
          <div class="date">{{ $moment(form.date).format("ll") }}</div>
          <div v-if="mobile">
            <CustomInput
              mb="10px"
              v-model="form.date"
              type="date"
              @change="reloadChanged"
            />
          </div>
          <div class="timepicker">
            <div class="inp">
              <CustomInput
                step="1800"
                type="time"
                v-model="form.start"
                @change="errors.start = null"
              />
            </div>
            <span class="strip">-</span>
            <div class="inp">
              <CustomInput
                step="1800"
                type="time"
                v-model="form.end"
                @change="errors.end = null"
              />
            </div>
          </div>
          <error-text :text="errors.start || errors.end" />
        </div>

        <template v-if="!emptyCoworking">
          <div>
            <div class="name">
              <CustomInput
                :value="clientName"
                placeholder="Клиент"
                v-debounce:300ms="loadClients"
              />
              <div class="name__dropdown" v-if="clients.length">
                <div
                  class="name__dropdown-item"
                  v-for="(client, idx) in clients"
                  :key="idx"
                  @click="setClient(client.client)"
                >
                  <img
                    height="50px"
                    v-if="client.client.avatar"
                    :src="client.client.avatar"
                    alt=""
                  />
                  <div>
                    <div class="title">{{ client.client.full_name }}</div>
                    <div class="phone">{{ client.client.phone }}</div>
                  </div>
                </div>
              </div>
            </div>
            <error-text :text="errors.client_id" />
          </div>
        </template>
        <template v-if="emptyCoworking">
          <router-link
            class="notification rent"
            :to="{
              name: 'master.cabinet.calendar',
              params: { calendar: 'rents', fevent },
            }"
            v-if="emptyCoworking"
          >
            Арендовать рабочее место
          </router-link>
        </template>
      </template>
    </preload-content>
    <button class="save" @click="submit()" :disabled="disabled">
      Сохранить
    </button>
  </div>
</template>

<script>
import ErrorText from "@/components/ui/text/error-text";
import CustomInput from "@/components/ui/inputs/custom-input";
import CustomSelect from "@/components/ui/inputs/custom-select";
import moment from "moment";
import PreloadContent from "@/components/ui/preload-content";

export default {
  name: "createWModal",
  components: { PreloadContent, CustomSelect, CustomInput, ErrorText },
  data: () => ({
    errors: {},
    clients: [],
    mobile: false,
    coworking: null,
    form: {
      date: "",
      start: "",
      end: "",
      title: "",
      price: "",
      client: "",
      type: "",
      cowork: "",
    },
    fevent: null,
    show: false,
    edit: false,
    coords: {
      left: 0,
      right: 0,
    },
  }),
  computed: {
    clientName() {
      return this.form.client
        ? this.form.client.name + " " + this.form.client.surname
        : null;
    },
    emptyCoworking() {
      return this.coworking && !this.coworking.length;
    },
    loading() {
      return !this.coworking;
    },
    disabled() {
      return this.loading || !this.coworking.length;
    },
    types() {
      return this.coworking
        .filter((val) => val.id === parseInt(this.form.cowork))
        .map((val) => val.zones)[0];
    },
  },
  methods: {
    loadClients(search) {
      this.form.client = null;
      this.$api.master.client
        .list({ perPage: 50, search })
        .then(({ data }) => (this.clients = data));
    },
    loadCoworking(rent_from, rent_to) {
      this.$api.coworking
        .list({ perPage: 100, rent_from, rent_to })
        .then(({ data }) => {
          this.coworking = data;
          if (!this.coworking.length)
            return this.$toast.error(
              "Вы не можете создать заказ по клиенту пока не забронируете место в коворкинге"
            );
        });
      return this;
    },
    create() {
      this.$api.master.record
        .create(this.getSaveData())
        .then(({ data }) => {
          this.$toast.success("Новая запись успешно создана!");
          this.$emit("create", data);
          this.close();
        })
        .catch(({ response }) => {
          if (response.data.exception && response.data.message)
            this.$toast.error(response.data.message);
          if (response.data.errors) this.errors = response.data.errors;
        });
    },
    update() {
      this.$api.master.record
        .update(this.form.id, this.getSaveData())
        .then(({ data }) => {
          this.$toast.success("Сохранено!");
          this.$emit("edit", data);
          this.close();
        })
        .catch(({ response }) => {
          if (response.data.errors) this.errors = response.data.errors;
        });
    },
    submit() {
      this.edit ? this.update() : this.create();
    },
    open(e, edit = false) {
      this.clear();
      let start,
        end = null;
      if (e != undefined) {
        this.fevent = e;
        start = e.event ? e.event.start : e.startStr;
        end = e.event ? e.event.end : e.endStr;
      } else {
        if (
          this.$moment().diff(
            this.$moment()
              .hour(21)
              .minute(30)
              .second(0)
              .millisecond(0),
            "hours"
          ) < 1
        ) {
          e = {};
          e.start = start =
            this.$moment().get("minute") >= 30
              ? this.$moment()
                  .minute(0)
                  .second(0)
                  .add(1, "hour")
                  .toDate()
              : this.$moment()
                  .minute(30)
                  .second(0)
                  .toDate();
          e.end = end = this.$moment(start)
            .add(30, "minute")
            .toDate();
        } else {
          return this.$toast.error("На сегодня уже нельзя создать заявку");
        }
      }
      if (moment(start).diff(moment(), "minutes") <= 1)
        return this.$toast.error(
          "Невозможно создать запись на прошедшую дату!"
        );
      edit ? this.setEditData(e) : this.setCreateData(e);
      this.loadCoworking(
        moment(start).format("YYYY-MM-DD HH:mm:ss"),
        moment(end).format("YYYY-MM-DD HH:mm:ss")
      )
        .setModalPosition(e)
        .setEdit(edit)
        .setShow(true);
    },
    setClient(client) {
      this.form.client = client;
      this.errors.client_id = null;
      this.clients = [];
    },
    setShow(show = true) {
      this.show = show;
      if (show) this.$emit("opened");
      return this;
    },
    setEdit(edit = true) {
      this.edit = edit;
      return this;
    },
    setModalPosition(e) {
      if (window.innerWidth < 425) {
        this.mobile = true;
        this.$refs.pop.style.left = "0px";
        this.$refs.pop.style.bottom = "0px";
      } else {
        this.mobile = false;
        //offsets section
        let w = this.$refs.pop.offsetWidth;
        let h = this.$refs.pop.offsetHeight;
        let left = Math.abs(
          e.jsEvent.x - e.jsEvent.layerX + e.jsEvent.target.clientWidth + w
        );
        let offset = 10;
        let lofSet = document.body.clientWidth - left;
        if (lofSet > 0) {
          lofSet = offset;
        } else {
          lofSet = -e.jsEvent.target.clientWidth - w - offset;
        }
        left -= w;
        let scrY = window.scrollY;
        if (
          document.body.offsetHeight <
          e.jsEvent.y - e.jsEvent.layerY + window.scrollY + h
        )
          scrY = -h + e.jsEvent.target.clientHeight + window.scrollY;
        //offsets end
        //coords section
        this.$refs.pop.style.left = left + lofSet + "px";
        this.$refs.pop.style.top =
          Math.abs(e.jsEvent.y - e.jsEvent.layerY + scrY) + "px";
        //coords end
      }
      return this;
    },
    setCreateData(e) {
      if (e.zone) {
        this.form.cowork = e.zone.coworking_id.toString();
        this.form.type = e.zone.id.toString();
      }
      this.form.date = this.$moment(e.start).format("YYYY-MM-DD");
      this.form.edate = this.$moment(e.end).format("YYYY-MM-DD");
      this.form.start = this.$moment(e.start).format("HH:mm");
      this.form.end = this.$moment(e.end).format("HH:mm");
    },
    setEditData(e) {
      this.form.date = this.$moment(e.event.start).format("YYYY-MM-DD");
      this.form.edate = this.$moment(e.event.end).format("YYYY-MM-DD");
      this.form.start = this.$moment(e.event.start).format("HH:mm");
      this.form.end = this.$moment(e.event.end).format("HH:mm");
      this.form.title = e.event.extendedProps.name;
      this.form.id = e.event.id;
      this.form.price = e.event.extendedProps.sum;
      this.form.client = e.event.extendedProps.client;
      this.form.cowork = e.event.extendedProps.coworking_id;
      this.form.type = e.event.extendedProps.zone
        ? e.event.extendedProps.zone.id
        : null;
    },
    getSaveData() {
      return {
        name: this.form.title,
        sum: this.form.price,
        client_id: this.form.client ? this.form.client.id : "",
        start: this.getDate(this.form.date, this.form.start),
        end: this.getDate(this.form.edate, this.form.end),
        coworking_id: this.form.cowork,
        zone_id: this.form.type,
      };
    },
    getDate(date, time) {
      if (!date || !time) return "";
      return moment(date, "YYYY-MM-DD")
        .set("hours", time.split(":")[0])
        .set("minutes", time.split(":")[1])
        .format("YYYY-MM-DD HH:mm:ss");
    },
    reloadChanged() {
      this.loadCoworking(
        this.getDate(this.form.date, this.form.start),
        this.getDate(this.form.edate, this.form.end)
      );
    },
    clear(mobile) {
      this.fevent = null;
      this.form = {
        date: "",
        start: mobile ? "09:00" : "",
        end: mobile ? "10:00" : "",
        title: "",
        price: "",
        client: "",
        type: "",
        cowork: "",
      };
      this.coworking = null;
      this.search = [];
      this.errors = {};
    },
    close() {
      this.show = false;
      this.clear();
    },
  },
  watch: {
    "form.date"(n) {
      if (this.mobile) {
        this.form.edate = n;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.notification {
  font-size: 16px;
  text-decoration: none;

  &.rent {
    color: #b9765b;
  }
}

.popup {
  display: inline-block;
  z-index: 100;
  position: absolute;
  left: 0;
  top: 230px;
  background-color: #ffffff;
  border: 2px solid #dbbfa7;
  border-radius: 5px;
  padding: 15px 20px 20px 20px;
  max-width: 365px;
  width: 100%;
  //overflow: hidden;
}

.mobile-header {
  border-radius: 10px 10px 0 0;
  background: #dbbfa7;
  height: 50px;
  position: absolute;
  left: 0;
  right: 0;
  top: -49px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px;

  &.title {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: #383838;
  }

  & button {
    background-color: transparent;
    border: none;
    width: 20px;
    height: 20px;

    img {
      max-width: 100%;
    }
  }
}

.top {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;

  button {
    background-color: transparent;
    border: none;
    width: 20px;
    height: 20px;

    img {
      max-width: 100%;
    }
  }
}

.date {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.7;
  color: #808080;
  margin-bottom: 10px;
}

.timepicker {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .inp {
    width: 100px;
  }

  .strip {
    margin: 0 5px;
  }
}

.name {
  position: relative;

  &__dropdown {
    z-index: 10;
    position: absolute;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(0, 0, 0, 0.04),
      0 0 1px rgba(0, 0, 0, 0.04);
    right: 0;
    left: 0;
    top: 52px;
    border: 1px solid #dbbfa7;
    border-radius: 5px;
    overflow: hidden;

    &-item {
      display: flex;
      align-items: center;
      padding: 10px 15px;
      border-bottom: 1px solid #e5e5e5;
      background-color: #fff;
      cursor: pointer;

      img {
        margin-right: 10px;
      }

      .title {
        font-size: 16px;
        line-height: 1.5;
        color: #383838;
      }

      .phone {
        font-size: 14px;
        line-height: 1.7;
        color: #808080;
      }
    }
  }
}

.save {
  height: 48px;
  margin-left: -22px;
  margin-right: -22px;
  width: calc(100% + 44px);
  margin-bottom: -2px;
  transform: translateY(20px);
  border: 2px solid #dbbfa7;
  background-color: #fff;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #808080;
}

@media screen and (max-width: 991px) and (min-width: 426px) {
  .popup {
    max-width: 100%;
    position: fixed;
    left: 0 !important;
    top: 20px !important;
    bottom: 0;
    right: 0;
  }
}

@media (max-width: 425px) {
  .popup {
    max-width: 100%;
    position: fixed;
    left: 0 !important;
    top: unset !important;
    bottom: 0;
    right: 0;
    border: unset;
  }

  .save {
    width: 100%;
    border-radius: 5px;
    border: unset;
    background-color: #dbbfa7;
    color: #383838;
    margin: 15px auto;
  }
}
</style>
